<script>
import { ArrowUpIcon, ShieldIcon, CpuIcon, VideoIcon } from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";
import countTo from "vue-count-to";

import Navbar from "@/components/navbar";
import Features from "@/components/features";
import Footer from "@/components/footer";
import axios from "axios";
import config from "@/config.json";
import {post} from "@/assets/js/utils";

/**
 * Index-classic-saas component
 */
export default {
  data() {
    const ua = navigator.userAgent.toLowerCase();
    const os = ua.indexOf("mac") > 0? 'mac' : 'win';
    return {
      downloadUrl: "#",
      os : os,
      selected: os,
      lang: this.getLang(),
      release: {
        app: "",
        vcname: "",
        vc: 0,
        mac_url: "",
        win_url: "",
        created_at: "",
      }
    };
  },
  mounted() {
    this.getRelease();
  },
  methods: {
    async getRelease() {
      try {
        const data = await post(`${config.api.latestrelease}`, {app: "Sketch.Mirror"});
        if (data.errno === 0) {
          this.release = data.data;
          this.downloadUrl = this.release.mac_url;
        } else {
        }
      } catch (e) {}
    },
  },
  components: {
    Navbar,
    Footer,
    Features,
    ArrowUpIcon,
    Carousel,
    Slide,
    countTo,
    ShieldIcon,
    CpuIcon,
    VideoIcon
  },
};
</script>

<template>
  <div>
    <Navbar />
    <!-- Hero Start -->
    <section class="bg-half-170 d-table w-100 overflow-hidden" id="home">
      <div class="container">
        <div class="row align-items-center pt-5">
          <div class="col-lg-7 col-md-6">
            <div class="title-heading">
              <h1 class="heading mb-3">{{$t('sketch.title')}} </h1>
              <p class="para-desc text-muted"> {{$t('sketch.description')}} </p>
              <span class="badge badge-pill badge-info"> {{$t('sketch.version_support')}}</span>
              <div class="mt-4 pt-2">
                <a :href="downloadUrl" onclick="_czc.push(['_trackEvent', 'app', 'download', 'sketch']);" class="btn btn-primary ml-2" >{{$t('sketch.download')}} <i class="mdi mdi-download"></i ></a>
              </div>
              <div>
                <span class="badge badge-pill badge-outline-light">
                  {{$t('photoshop.version')}} <span> {{release.vcname}}</span>
                  {{$t('photoshop.update_time')}} <span> {{release.created_at | formatDate}} </span>
                </span>
              </div>

            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <div class="classic-saas-image position-relative">
              <div class="bg-saas-shape position-relative">
                <img width="2048" height="1228" loading="eager" fetchpriority="high"
                  src="/images/photoshop/classic01.png" :alt="$t('alt.sketch_panel')" style="width: 1024px; margin-left: 100px;" />
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Key Feature Start -->
    <div class="container mt-5 mb-5">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <div class="section-title mb-4 pb-2">
            <h2 class="h4 title mb-4">{{$t('photoshop.install.title')}}</h2>
            <p class="text-muted para-desc mx-auto mb-0">{{$t('photoshop.install.description')}} </p>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->

      <div class="row">
        <div class="col-lg-6 col-md-6">
          <img width="1470" height="1112" loading="lazy" src="/images/photoshop/Snip20211218_7.png" class="img-fluid" :alt="$t('alt.sketch_install')" />
          <br/>
          <br/>
          <img width="636" height="148" loading="lazy" src="/images/photoshop/Snip20211218_9.png" class="img-fluid" :alt="$t('alt.sketch_install')" />
        </div>
        <!--end col-->

        <div class="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
          <div class="section-title ml-lg-3">
            <h2 class="h4 title mb-4">
              {{$t('sketch.install.step1.title')}}
            </h2>
            <p class="text-muted dm-multiline"> {{$t('sketch.install.step1.detail')}} </p>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->

      <div class="row mt-5" v-if="lang === 'zh'">
        <div class="col-lg-6 col-md-6">
          <img width="1064" height="590" loading="lazy" src="/images/photoshop/can_not_open.png" class="img-fluid" alt="" />
          <br/>
          <br/>
          <img width="800" height="500" loading="lazy" src="/images/photoshop/3f5c6d6f60d869884293b5177e16a13e.jpeg" class="img-fluid" alt="" />
        </div>
        <!--end col-->

        <div class="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
          <div class="section-title ml-lg-3">
            <h2 class="h4 title mb-4 text-warning">
              {{$t('photoshop.install.step2.title')}}
            </h2>
            <p class="text-muted"> {{$t('photoshop.install.step2.detail')}} </p>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->

    </div>
    <!--end container-->
    <!-- Key Feature End -->


    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style scoped>
/* 安装说明用 \n 分段；HTML 默认会把换行折叠成空格。 */
.dm-multiline {
  white-space: pre-line;
}
</style>
